<script lang="ts" setup>
import { ref, computed, watch } from 'vue';

import { storeToRefs } from 'pinia';
import { useLocalizationStore } from '@/stores/localization';
import { useUserStore } from '@/stores/user';
import { useModalsStore } from '@/stores/modals';
import { usePaymentStore } from '@/stores/payment';
import { numbersOnly } from '@/utils';

const userStore = useUserStore();
const paymentStore = usePaymentStore();
const { isLoggedIn } = useUserStore();
const { toggleModal } = useModalsStore();
const { numbers, credits_per_minute, hasIVR } = storeToRefs(useLocalizationStore());

const emit = defineEmits(['initiate']);
const props = defineProps<{ performer: any, form: { ivrCode:number, name:string, errors: any } , isLoading: boolean }>();

function initiateIVRService() {
    emit('initiate', {type: 'teaser', ivrCode: props.form.ivrCode, name: props.form.name})
}

function initiateCreditsService() {
    paymentStore.code = undefined;
    emit('initiate', { type: 'teaser' })
}

const displayedCreditsPerMinute = computed(() => {
    if(!credits_per_minute?.value) return 'N/A';
    return Math.round(parseFloat(credits_per_minute?.value));
});
</script>

<template>
    <div class="tabs__content">

        <div class="tabs__content-colum2" v-if="hasIVR">
            <h2 v-html="$t('tabs.paymentwithtelephone')"></h2>

            <div class="numbers">
                <span v-for="i of numbers" class="numbers__nr">
                    <i :class="`numbers__nr-flag  fflag fflag-${i.country.toUpperCase()} ff-md`"></i> 
                    {{ i.number }}<b>{{ $filters.currency(i.tariff) }}  {{ $t('header.numbers.currency') }}</b>
                </span>
            </div>

            <p>{{ $t('tabs.webcamwithphonedesc') }}</p>
            <form @submit.prevent="initiateIVRService()">
                <div class="row">
                    <div class="row__col2">
                        <div class="form__group form__group-small" :class="{'form__group-disabled': 'code' in form.errors }">
                            <input v-model="form.ivrCode" type="tel" min="0" max="99999" maxlength="5" :placeholder="$t('tabs.accesscode')" name="ivr" required @keypress="numbersOnly"> 
                        </div>
                    </div>
                    <div class="row__col2">
                        <div class="form__group form__group-small" :class="{'form__group-disabled': 'name' in form.errors }">
                            <input v-model="form.name" type="text" maxlength="30" :placeholder="$t('tabs.username')" required>
                        </div>
                    </div>
                </div>

                <div class="tabs__content-bottom">
                    <button class="btn btn-full btn-small btn-green" :class="{'non-disabled': isLoading }" type="submit">{{ $t('tabs.voyeurbtn') }}</button>
                </div>
            </form>
        </div>

        <div :class="{ 'tabs__content-colum2': hasIVR , 'tabs__content-colum1': !hasIVR }">
            <h2 v-html="$t('tabs.paymentwithcredits')"></h2>
            <p>
                <span>{{ $t('tabs.voyeurwithcreditsdesc', { creditValue: displayedCreditsPerMinute }) }}</span>
            </p>

            <div class="tabs__content-bottom">
                <button v-if="!isLoggedIn()" class="btn btn-full btn-small btn-green" @click="toggleModal('login')">{{ $t('modals.login.title') }}</button>
                <button v-if="isLoggedIn()" class="btn btn-full btn-small btn-green" :class="{ 'non-disabled': isLoading }" @click="initiateCreditsService()">{{ $t('tabs.voyeurbtn') }}</button>
            </div>
        </div>

    </div>
</template>